import React from 'react';
import PintGlass from './svg/PintGlass';
import AlcopopBottle from './svg/AlcopopBottle';
import Availability from './svg/Availability';
import Crime from './svg/Crime';
import Harms from './svg/Harms';
import Health from './svg/Health';
import LargeCan from './svg/LargeCan';
import LargeWine from './svg/LargeWine';
import Marketing from './svg/Marketing';
import MediumWine from './svg/MediumWine';
import People from './svg/People';
import Policy from './svg/Policy';
import Research from './svg/Research';
import ShotGlass from './svg/ShotGlass';
import SmallCan from './svg/SmallCan';
import SmallWine from './svg/SmallWine';
import Society from './svg/Society';
import Support from './svg/Support';
import Treatment from './svg/Treatment';
import Trends from './svg/Trends';
import WineBottle from './svg/WineBottle';
import Fundraising from './svg/Fundraising';
import Campaign from './svg/Campaign';

class SvgIcon extends React.Component {
    renderIcon() {
        switch(this.props.icon){
            case 'alcopop-bottle': return <AlcopopBottle />;
            case 'availability': return <Availability />;
            case 'crime': return <Crime />;
            case 'harms': return <Harms />;
            case 'health': return <Health />;
            case 'large-can': return <LargeCan />;
            case 'large-wine': return <LargeWine />;
            case 'marketing': return <Marketing />;
            case 'med-wine': return <MediumWine />;
            case 'people': return <People />;
            case 'policy': return <Policy />;
            case 'research': return <Research />;
            case 'shot-glass': return <ShotGlass />;
            case 'small-can': return <SmallCan />;
            case 'small-wine': return <SmallWine />;
            case 'society': return <Society />;
            case 'support': return <Support />;
            case 'treatment': return <Treatment />;
            case 'trends': return <Trends />;
            case 'wine-bottle': return <WineBottle />;
            case 'fundraising': return <Fundraising />;
            case 'campaign': return <Campaign />;

            default: return <PintGlass />;
        }
    }
  render () {
    const icon = this.renderIcon();

    return (
        <React.Fragment>{icon}</React.Fragment>
    );
  }
}

export default SvgIcon;
